import api from "./api";

const holidayService = {
  list() {
    return api.get("/holidays");
  },
  show(id) {
    return api.get(`/holidays/${id}`);
  },
  create(data) {
    return api.post("/holidays", data);
  },
  update(id, data) {
    return api.put(`/holidays/${id}`, data);
  },
  remove(id) {
    return api.delete(`/holidays/${id}`);
  },
  // ── Defaults ──
  getDefaults() {
    return api.get("/holidays/defaults");
  },
  updateDefaults(data) {
    return api.put("/holidays/defaults", data);
  },
  // ── Seed & Import ──
  seed(years) {
    return api.post("/holidays/seed", { years });
  },
  seedState(uf) {
    return api.post("/holidays/seed-state", { uf });
  },
  getAvailableUfs() {
    return api.get("/holidays/available-ufs");
  },
  importPreview(year, source) {
    return api.post("/holidays/import/preview", { year, source });
  },
  importConfirm(holidays) {
    return api.post("/holidays/import/confirm", { holidays });
  }
};

export default holidayService;
